import React from 'react';
import styled from 'styled-components';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';

import portraitWebP from '../../../assets/images/reviews/yuja-wang.webp';
import portraitPng from '../../../assets/images/reviews/yuja-wang.png';
import avatar from '../../../assets/images/reviews/yuja-wang-avatar.png';

const ARTIST_NAME = 'Yuja Wang';

const messages = defineMessages({
  quote: {
    id: 'reviews.featured.quote',
    defaultMessage:
      '“I adore IDAGIO. It’s easy to use and it brings classical music to people around the world. I’m so happy to share this ingenious platform with my fans.”',
  },
  role: {
    id: 'reviews.featured.role',
    defaultMessage: 'Pianist',
  },
});

const PORTRAIT_WIDTH = '38%';

const Wrapper = styled.div`
  background-color: var(--c-shark);
  border-radius: var(--fr);
  overflow: hidden;
  padding: calc(var(--fr) * 2) calc(var(--fr) * 1.5);
  position: relative;
  display: flex;
  flex-direction: column;

  ${media.large`
    padding: calc(var(--fr) * 3);
    min-height: 25rem;
    border-radius: var(--fr) 0 0 var(--fr);
  `}
`;

const Content = styled.figure`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${media.medium`
    padding-right: ${PORTRAIT_WIDTH};
  `}
`;

const Quote = styled.blockquote`
  font-size: var(--fs-ml);
  ${legacyType('ml', 'title')};
  margin: 0;
`;

const Attribution = styled.figcaption`
  align-items: center;
  display: flex;
  margin-top: auto;
  padding-top: calc(var(--fr) * 2);

  .avatar {
    border-radius: 50%;
    flex-shrink: 0;
    height: calc(var(--fr) * 2.5);
    margin-right: calc(var(--fr) * 0.75);
    width: calc(var(--fr) * 2.5);
  }

  .name {
    font-size: var(--fs-s);
    font-weight: 700;
  }

  .role {
    color: var(--c-manatee);
    font-size: var(--fs-s);
  }
`;

const Portrait = styled.picture`
  align-self: flex-end;
  margin-bottom: calc(var(--fr) * -3);
  width: 90%;

  ${media.medium`
    bottom: 0;
    height: 100%;
    margin: 0;
    position: absolute;
    right: calc(${PORTRAIT_WIDTH} / 4);
    width: ${PORTRAIT_WIDTH};

    img {
      height: 100%;
      object-fit: contain;
      object-position: bottom right;
    }
  `}
`;

const FeaturedReview = ({ intl }) => {
  return (
    <Wrapper>
      <Content>
        <Quote>{intl.formatMessage(messages.quote)}</Quote>
        <Attribution>
          <img className="avatar" src={avatar} alt="" />
          <div>
            <div className="name">{ARTIST_NAME}</div>
            <div className="role">{intl.formatMessage(messages.role)}</div>
          </div>
        </Attribution>
      </Content>
      <Portrait>
        <source srcSet={portraitWebP} type="image/webp" />
        <img src={portraitPng} alt={ARTIST_NAME} />
      </Portrait>
    </Wrapper>
  );
};

FeaturedReview.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(FeaturedReview);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/reviews/FeaturedReview.js